const NpsPorAjudante = ({ dados }) => {
    const getRatingClass = (value) => {
        if (value >= 2.5) return 'bg-green-100 text-green-800';
        if (value >= 2) return 'bg-indigo-100 text-indigo-800';
        if (value >= 1) return 'bg-yellow-100 text-yellow-800';
        return 'bg-red-100 text-red-800';
    }

    const getNpsScore = (value) => {
        if (value <= 10) return 'bg-red-100 text-red-800';
        if (value <= 30) return 'bg-yellow-200 text-yellow-800';
        if (value <= 50) return 'bg-green-100 text-green-800';
        if (value > 50) return 'bg-green-300 text-green-800';
    }

    const getNpsCategory = (value) => {
        if (value <= 6) return 'bg-red-100 text-red-800';
        if (value <= 8) return 'bg-yellow-100 text-yellow-800';
        if (value > 8) return 'bg-green-100 text-green-800';
    }

    return (
        <div className="overflow-auto bg-white p-4 rounded shadow">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">NPS por Ajudante</h3>
            <table className="min-w-full text-sm">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="text-left px-4 py-2 border">Ajudante</th>
                        <th className="text-left px-4 py-2 border">Total NPS</th>
                        <th className="text-left px-4 py-2 border">Média NPS</th>
                        <th className="text-left px-4 py-2 border">Abordagem</th>
                        <th className="text-left px-4 py-2 border">Estoque</th>
                        <th className="text-left px-4 py-2 border">Produto</th>
                        <th className="text-left px-4 py-2 border">Resolução</th>
                        <th className="text-left px-4 py-2 border">Entrega</th>
                        <th className="text-left px-4 py-2 border">NPS Score</th>
                    </tr>
                </thead>
                <tbody>
                    {dados.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                            <td className="px-4 py-2 border font-medium">{item.id} - {item.name || "Nome não cadastrado"}</td>
                            <td className="px-4 py-2 border">{item.totalNotas}</td>
                            <td className={`text-center px-4 py-2 border ${getNpsCategory(item.mediaNps)}`}>{item.mediaNps}</td>
                            <td className={`text-center px-4 py-2 border ${getRatingClass(item.mediaTeamApproach)}`}>{item.mediaTeamApproach}</td>
                            <td className={`text-center px-4 py-2 border ${getRatingClass(item.mediaTeamApproach)}`}>{item.mediaStorageCheck}</td>
                            <td className={`text-center px-4 py-2 border ${getRatingClass(item.mediaTeamApproach)}`}>{item.mediaProductQuality}</td>
                            <td className={`text-center px-4 py-2 border ${getRatingClass(item.mediaTeamApproach)}`}>{item.mediaIssueResolution}</td>
                            <td className={`text-center px-4 py-2 border ${getRatingClass(item.mediaTeamApproach)}`}>{item.mediaDeliveryTime}</td>
                            <td className={`text-center px-4 py-2 font-semibold border ${getNpsScore(item.npsScore)}`}>{item.npsScore}</td>
                        </tr>
                    ))}
                    {dados.length === 0 && (
                        <tr>
                            <td colSpan="9" className="text-center py-4 text-gray-500">
                                Nenhum dado encontrado para o período.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default NpsPorAjudante;
